export default "__VITE_ASSET__CPhIG6$U__"